import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  standalone: true,
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, stringToFind: string, replaceWith: string): string {
    if (!value || stringToFind === undefined || replaceWith === undefined) {
      return value;
    }

    return value.replaceAll(stringToFind, replaceWith);
  }
}
